import { Icon } from '@eventbrite/eds-icon';
import { FlagChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React, { useContext, useState } from 'react';
import {
    EventBasicInformation,
    EventBasicInformationContext,
} from '../../contexts/EventContext';
import { CountryProps, LanguageProps } from '../../types/i18n';
import { EventDetailsMainInner } from '../EventDetails/EventDetails';
import './ReportThisEventButton.scss';
import { ReportThisEventController } from './ReportThisEventController';

type ReportThisEventButtonProps = CountryProps & LanguageProps;

export const ReportThisEventButton: React.FC<ReportThisEventButtonProps> = ({
    country,
    helpCenterLanguage,
}) => {
    const {
        id: eventId,
        name: eventName,
        url: eventUrl,
    } = useContext(EventBasicInformationContext) as EventBasicInformation;

    const [visible, setVisible] = useState(false);
    return (
        <EventDetailsMainInner>
            <span
                data-testid="report-this-event-button"
                className="eds-align--center"
            >
                <div className="report-event-button">
                    <Button variant="ghost" onClick={() => setVisible(true)}>
                        <div className="button-inner">
                            <Icon type={<FlagChunky />} size="small" />
                            <span>{gettext('Report this event')}</span>
                        </div>
                    </Button>
                </div>
                <ReportThisEventController
                    event={{
                        id: eventId,
                        name: eventName,
                        url: eventUrl,
                    }}
                    isReportThisEventVisible={visible}
                    setIsReportThisEventVisible={setVisible}
                    country={country}
                    helpCenterLanguage={helpCenterLanguage}
                />
            </span>
        </EventDetailsMainInner>
    );
};
